import { Box, Typography } from "@mui/material";
import logo from "../../assets/images/logo_light.svg";

function Footer() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        borderTop: "1px solid rgba(255, 255, 255, 0.25)",
        mt: 30,
        flexDirection: "column",
        alignItems: "center",
        width: { xs: "100%", md: "90%" },
        mx: "auto",
      }}
    >
      <Box component="img" src={logo} sx={{ width: "140px", mt: 6, mb: 3 }} />
      <Typography
        sx={{
          mb: 6,
          color: "rgba(255, 255, 255, 0.5)",
          fontFamily: "Outfit",
          fontSize: "17px",
          fontWeight: 400,
        }}
      >
        © 2025. All rights reserved.
      </Typography>
    </Box>
  );
}

export default Footer;
